import extractInterfaceName from "../extractInterfaceName";
import isTrafficOrPower from "../isTrafficOrPowerItem";

const extractInterfaceSelected = (itensConn, interfaces) => {
  const selectedItem = itensConn?.find((item) => isTrafficOrPower(item?.key_));
  if (!selectedItem) return null;
  const interfaceSelected = interfaces?.find(
    (inte) => inte?.interface === extractInterfaceName(selectedItem?.key_)
  );
  if (!interfaceSelected) return null;
  return interfaceSelected;
};

export default extractInterfaceSelected;
